'use client';
import type { CategoryTreeResponse } from '@/types/categories';
import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import type { TelegramCategoryControllerGetTreeQueryResponse } from '@/generated/types/TelegramCategoryControllerGetTree';
export const categoryTreeKey = (lang: string) => ['categories-v2', lang] as const;
export function useCategoryTree() {
  const lang = useLocale();
  return useQuery({
    queryKey: categoryTreeKey(lang),
    staleTime: Infinity,
    refetchOnReconnect: false,
    queryFn: async ({ signal }): Promise<TelegramCategoryControllerGetTreeQueryResponse> => {
      const response = await fetch(`/api/categories/tree?lang=${lang}`, { cache: 'no-store', signal });
      if (!response.ok) throw new Error('Categories unavailable');
      const body: CategoryTreeResponse = await response.json();
      return body.tree;
    },
  });
}
